module.exports = __webpack_public_path__ + "img/DW365-219.7bb8faff.jpg";